module.exports = __webpack_public_path__ + "img/cross-crop.58c68199.jpg";